import { formatDuration, formatShortDuration } from "@helpers/utils";

import type { FieldRenderer } from "../types";

const renderer: FieldRenderer = (fieldValue: unknown) => {
  return {
    formattedText: formatShortDuration(fieldValue as number),
    tooltipText: formatDuration(fieldValue as number),
  };
};

export default renderer;
